import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

export interface GoalI {
  id?: number;
  init_date: Date;
  description: string;
  position: number;
  active?: boolean;

  upload_user: string;
}

@Injectable({
  providedIn: 'root',
})
export class GoalService {
  constructor(private readonly http: HttpClient) {}

  private url = `${environment.url}dashboard-goal`;

  insert(goal: GoalI[]) {
    return this.http.post<BackendResponse>(this.url, goal).pipe(
      map((data) => data.result as GoalI),
      catchError((e) => handleError(e))
    );
  }

  getAll() {
    return this.http.get<BackendResponse>(this.url).pipe(
      map((data) => data.result as GoalI[]),
      catchError((e) => handleError(e))
    );
  }
}
